import elementTextFilter from '../../../../modules/Gull/Framework/elementTextFilter.js';

const edit = {
	init() {
		var elementTextFilterElement = document.querySelector('[data-element-text-filter-input]');
		elementTextFilter.init(elementTextFilterElement);
		edit.toggleToestemmingen();
		edit.toggleAutovalidatieSalaris();

		edit.initEvents();
	},

	initEvents() {
		$('#neemDefaultToestemmingenOver').on('change', function () {
			edit.toggleToestemmingen();
		});

		$('#actieSalarisAutovalidatie').on('change', function () {
			edit.toggleAutovalidatieSalaris();
		});

		$('.nav-link#rechten-tab').on('click', function () {
			document.querySelector('[data-element-text-filter-input]').focus();
		});
	},

	// Functie om toestemmingsswitches te tonen en verbergen
	toggleToestemmingen: function () {
		var checked = $('#neemDefaultToestemmingenOver').prop('checked');
		var target = $('[data-default-toestemming]').closest('.form-group');
		target.addClass('d-none');
		if (checked) {
			target.removeClass('d-none');
		}
	},

	// Functie om toestemmingsswitches te tonen en verbergen
	toggleAutovalidatieSalaris: function () {
		var checked = $('#actieSalarisAutovalidatie').prop('checked');
		var target = $('[data-salaris-autovalidatie]').closest('.form-group');
		target.addClass('d-none');
		if (checked) {
			target.removeClass('d-none');
		}
	},
};

export default edit;
